import { render, staticRenderFns } from "./form-getente.vue?vue&type=template&id=1d12e356&"
import script from "./form-getente.vue?vue&type=script&lang=js&"
export * from "./form-getente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports